import { render, staticRenderFns } from "./SendEgiftPanelRefundPolicy.vue?vue&type=template&id=13b7c628&scoped=true"
import script from "./SendEgiftPanelRefundPolicy.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelRefundPolicy.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelRefundPolicy.vue?vue&type=style&index=0&id=13b7c628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b7c628",
  null
  
)

export default component.exports